export type ClarifyType = 'generic' | 'press' | 'pitch' | 'social' | 'research' | 'quality_review';

export interface ClarifyRequest {
  id: string;
  type: ClarifyType;
  questions: string[];
  agentLabel?: string;
  originRunId?: string;
  createdAt: number;
  locale?: 'en' | 'ar';
}

export interface ClarificationSubmissionMeta {
  requestId: string;
  type: ClarifyType;
  questions: string[];
  answers: string[];
  placeholderCount: number;
  compiledText: string;
  skipped?: boolean;
  agentLabel?: string;
  originRunId?: string;
}

export const CLARIFY_SKIP_TOKEN = '__USER_SKIPPED_CLARIFICATION__';

export function buildClarifySkipToken(type?: string): string {
  const normalizedType = typeof type === 'string' ? type.trim() : '';
  return `${CLARIFY_SKIP_TOKEN}:${normalizedType || 'unknown'}`;
}

export function parseClarifySkipToken(value: unknown): ClarifyType | 'unknown' | null {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!trimmed.startsWith(`${CLARIFY_SKIP_TOKEN}:`)) return null;
  const rawType = trimmed.slice(CLARIFY_SKIP_TOKEN.length + 1).trim().toLowerCase();
  if (!rawType) return 'unknown';
  if (rawType === 'generic' || rawType === 'press' || rawType === 'pitch' || rawType === 'social' || rawType === 'research' || rawType === 'quality_review') {
    return rawType;
  }
  return 'unknown';
}

export function isClarifySkipToken(value: unknown): boolean {
  return parseClarifySkipToken(value) !== null;
}
